import { render, staticRenderFns } from "./DialogEditUser.vue?vue&type=template&id=3b2548b2&scoped=true"
import script from "./DialogEditUser.vue?vue&type=script&lang=js"
export * from "./DialogEditUser.vue?vue&type=script&lang=js"
import style0 from "./DialogEditUser.vue?vue&type=style&index=0&id=3b2548b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2548b2",
  null
  
)

export default component.exports